/**
 * Mirrors backend backoffice_routes._get_claim_for_proposta_id:
 * tolerant matching on claimedProposals keys (PRP- prefix, -D{n} duplicate suffix).
 */

function canonicalPropostaId(value: string | number | null | undefined): string {
  if (value == null) return '';
  let s = String(value).trim();
  if (!s) return '';
  if (s.startsWith('PRP-')) s = s.replace(/^PRP-/, '');
  s = s.replace(/-D\d+$/i, '');
  return s;
}

export function getClaimForPropostaId(
  claimedProposals: Record<string, unknown> | null | undefined,
  propostaId: string | number | null | undefined
): Record<string, any> | null {
  if (!claimedProposals || typeof claimedProposals !== 'object' || propostaId == null) return null;
  const pid = String(propostaId).trim();
  if (!pid) return null;

  const lookupKeys: string[] = [pid];
  if (pid.startsWith('PRP-')) lookupKeys.push(pid.replace(/^PRP-/, ''));
  else lookupKeys.push(`PRP-${pid}`);

  const basePid = pid.replace(/-D\d+$/i, '');
  if (basePid !== pid) {
    lookupKeys.push(basePid);
    if (basePid.startsWith('PRP-')) lookupKeys.push(basePid.replace(/^PRP-/, ''));
    else lookupKeys.push(`PRP-${basePid}`);
  }

  for (const key of lookupKeys) {
    const claim = claimedProposals[key];
    if (claim && typeof claim === 'object' && !Array.isArray(claim)) {
      return claim as Record<string, any>;
    }
  }

  const target = canonicalPropostaId(pid);
  for (const [key, claim] of Object.entries(claimedProposals)) {
    if (claim && typeof claim === 'object' && !Array.isArray(claim) && canonicalPropostaId(key) === target) {
      return claim as Record<string, any>;
    }
  }
  return null;
}
